export default __webpack_public_path__ + "static/media/Car-Big.38cd4db7.png";